import { useEffect, useReducer, useMemo, createContext } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion"
import axios from 'axios'
import { getHostName, getCid, getTid } from './base'
import './App.css'
import Login from './components/Login'
import Main from './components/MainComponent'
import EnterAmount from './components/EnterAmountComponent'
import GenerateQR from './components/GenerateQRComponent'
import TransactionHistory from './components/TransactionHistory'
import DetailsList from './components/DetailsListComponent'
import Articles from './components/ArticlesComponent'
import Cart from './components/CartComponent'
import Report from './components/ReportComponent'
import AdminArticles from './components/AdminArticlesComponent'
import AdminCashiers from './components/AdminCashiersComponent'
import PartialStorne from './components/PartialStorneComponent'
import UserManual from './components/UserManualComponent'
import SocialShare from './components/SocialMediaShareComponent'
import Loading from './components/LoadingComponent'
 
export const AuthContext = createContext()

function App() {

    const [state, dispatch] = useReducer( (prevState, action) => {
    
      // eslint-disable-next-line default-case
      switch (action.type) {
        case 'RESTORE_TOKEN':
          return {
            ...prevState,
            userToken: action.token,
            isLoading: false,
          };
        case 'VALIDATE_CREDS':
            return {
              ...prevState,
              isValidate: action.creds,
              isLoading: false,  
            };
        case 'SIGN_IN':
          return {
            ...prevState,
            isLoading: false,
            isValidate: 0,
            isSignout: false,
            isReconciled: false,
            isProcessed: true,
            userToken: action.creds.token,
            userRank: action.creds.rank,
            credentials: action.creds,
            transactionList: action.transactionLst,
	          pageNumber: null,
            articleList: [],
            cashierList: [],
            lastItemAdded: null,
            quantityNumber: 0,
            articleCategory: action.articleCat,
            unitCategory: action.unitCat,
            taxCategory: action.taxCat,
             
            dateStart: null,
            dateEnd: null,
            message: null
          };
        case 'SIGN_OUT':
          return {
            ...prevState,
            isSignout: true,
	          pageNumber: null, 
            isValidate: 0,
            userToken: null,
            userRank: null,
            articleList: [],
            cahierList: [],
            transactionList: [],
            editedArticle: null,
            editedCashier: null,
            prevPage: null,
            amountToPay: null,
            lastItemAdded: null,
            cartItems: [],
            itemDetails: null,
            quantityNumber: null,
            credentials: {},
            articleCategory: null,
            unitCategory: null,
            taxCategory: null,
            isReconciled: false,
            dateStart: null,
            dateEnd: null,
          };
        case 'SET_LOADING':
            return {
              ...prevState,
              isLoading: true,
          };
        case 'SET_PROCESSED':
            return {
              ...prevState,
              isProcessed: action.processed,
          };
	      case 'AMOUNT_QR':
          return {
            ...prevState,
	          pageNumber: 1,  
          };
        case 'ARTICLES_QR':
          return {
            ...prevState,
            pageNumber: 5,  
            };
	      case 'GENERATE_QR':
          return {
            ...prevState,
	          pageNumber: 2,
	          amountToPay: action.amount,  
          };
        case 'ADMIN_ARTICLES':
            return {
              ...prevState,
              pageNumber: 8,  
              };
        case 'SET_ARTICLE_LIST':
          return {
              ...prevState,
              articleList: action.items,  
              };
        case 'SET_CASHIER_LIST':
          return {
              ...prevState,
              cashierList: action.items,  
              };
        case 'SET_TRANSACTION_LIST':
          return {
                ...prevState,
                transactionList: action.items,  
              };
        case 'ADMIN_CASHIERS':
            return {
              ...prevState,
              pageNumber: 9,  
              };
        case 'TRANSACTION_HISTORY':
          return {
            ...prevState,
            pageNumber: 3,  
            };
        case 'DETAILS_LST':
          return {
            ...prevState,
            pageNumber: 4,
            itemDetails: action.item
            };
        case 'DETAILS_LIST':
              return {
                ...prevState,
                pageNumber: 4,
              };
        case 'EDIT_ARTICLE':
              return {
                ...prevState,
                editedArticle: action.item
            };
        case 'RESET_EA':
            return {
                ...prevState,
                editedArticle: null,  
            };
        case 'EDIT_CASHIER':
            return {
                ...prevState,
                editedCashier: action.item
            };
        case 'RESET_EC':
            return {
                ...prevState,
                editedCashier: null,  
            };
        case 'TRANSACTIONS_REPORT':
          return {
            ...prevState,
            pageNumber: 7,
          };     
        case 'RESET_PN':
	        return {
            ...prevState,
	          pageNumber: null, 
            itemDetails: null, 
          };
        case 'SET_PAGE_NUMBER':
          return {
            ...prevState,
            pageNumber: action.num,  
          };
        case 'SET_PREV_PAGE':
          return {
            ...prevState,
            prevPage: action.prevPageNum,  
          };
        case 'SET_QR_URL':
              return {
                ...prevState,
                qrURL: action.url,  
            };
        case 'SET_MESSAGE':
              return {
                ...prevState,
                message: action.msg,  
            };
        case 'SET_QR_IMAGE':
              return {
                ...prevState,
                qrImage: action.image,  
        };
        case 'SET_RECONCILED':
              return {
                ...prevState,
                isReconciled: action.num,  
            };
        case 'SET_DATE_START':
              return {
                ...prevState,
                dateStart: action.date,  
            };
        case 'SET_DATE_END':
              return {
                ...prevState,
                dateEnd: action.date,  
            };
        case 'LAST_ADDED_CART_ITEM':
          return {
            ...prevState,
            lastItemAdded: action.itemAdded,
            }; 
        case 'ADD_ITEM_TO_CART':
          return {
            ...prevState,
            cartItems: action.items,
            };
        case 'REMOVE_ITEM_FROM_CART':
          return {
            ...prevState,
            cartItems: action.items,
            quantityNumber: action.quantity,
          };
        case 'RESET_CART':
          return {
            ...prevState,
            cartItems: [],
            quantityNumber: 0,
            amountToPay: 0,
            lastItemAdded: null,
          };
        case 'CHANGE_LAST_ITEM_QUANTITY_NUMBER':
          return {
            ...prevState,
            cartItems: action.items,
            };
        case 'INCREMENT_QN':
          return {
            ...prevState,
            quantityNumber: action.quantNum,  
          };
        case 'PARTIAL_STORNE':
          return {
            ...prevState,
            pageNumber: 10,
          };
        case 'SET_ARTICLE_CATEGORY':
            return {
            ...prevState,
            articleCategory: action.items,
          };
        case 'SET_ATTEMPTS':
            return {
            ...prevState,
            attempts: action.attempts,
          };
        case 'SET_USERNAME':
            return {
            ...prevState,
            username: action.username,
          };
      }
    },
    {
      isLoading: false,
      isSignout: true,
      isProcessed: true,
      isValidate: 0,
      userToken: null,
      userRank: null,
      pageNumber: null,
      articleList: [],
      cahierList: [],
      transactionList: [],
      editedArticle: null,
      editedCashier: null,
      prevPage: null,
      amountToPay: null,
      lastItemAdded: null,
      cartItems: [],
      itemDetails: null,
      quantityNumber: null,
      credentials: {},
      articleCategory: null,
      unitCategory: null,
      taxCategory: null,
      isReconciled: false,
      dateStart: null,
      dateEnd: null,
      qrURL: null,
      qrImage: null,
      message: null,
      attempts: 0,
      username: null 
    }
  );

const getData = async (tid, token, cashier_id, rank, config) => {
           
        var id = parseInt(rank)!==0?0:cashier_id
    
        return await axios.post(getHostName() + '/advice_list', 
                { tid:tid, token:token, id:id }, config)
          .then(response => {
              return response.data
        }).catch(error => {
              console.log("Error happend while requesting the data...")
        })
  }

  const loginCashier = async (username, password) => {

        //var cid = window.location.pathname.split('/')[2]
        var obj = {}
        var category
        var unit
        var tax

        const requestBody = {
          username: username,
          password: password,          
      };

    await axios.post(getHostName() + '/cashier/login', requestBody).then(response => {
            if(response.data){
                //response.data.categories[0] is the article category
                //response.data.categories[1] is the article unit category
                //response.data.categories[1] is the article tax category
                localStorage.setItem("isReload", false)
                if(response.data.resultCode===0){ 
                      obj['token'] = response.data.result.cashier.token
                      obj['cid'] = response.data.result.cashier.cid
                      obj['tid'] = response.data.result.cashier.tid
                      obj['rank'] = response.data.result.cashier.rank
                      obj['cashier_id'] = response.data.result.cashier.id
                      obj['username'] = response.data.result.cashier.username
                      obj['store'] = response.data.result.cashier.retailerName
                      category = response.data.result.categories.categories
                      unit = response.data.result.categories.units
                      tax = response.data.result.categories.taxes

                      const config = {
                        headers:{
                          'X-Session-Token':response.data.result.cashier.token
                        }
                      };
                  
                      getData(response.data.result.cashier.tid, response.data.result.cashier.token, response.data.result.cashier.id, response.data.result.cashier.rank, config).then(apiData => {	 
                          if(apiData.resultCode===0){ 			
                              dispatch({ type:'SIGN_IN', creds:obj, articleCat:category, unitCat:unit, taxCat:tax, transactionLst:apiData.result })
                          }
                      })
                }else if(response.data.resultCode===1){
                    dispatch({ type: 'VALIDATE_CREDS', creds: response.data.resultCode })
                    dispatch({ type: 'SET_ATTEMPTS', attempts: response.data.result.cashier.attempts })
                }else{
                    console.log("To many attempts......")
                    dispatch({ type: 'VALIDATE_CREDS', creds: response.data.resultCode })
                    dispatch({ type: 'SET_ATTEMPTS', attempts: response.data.result.cashier.attempts })
                }
            }else{
              console.log("Empty response...")
              dispatch({ type: 'VALIDATE_CREDS', creds: -1 })
            }
        }).catch(error => {
                  //  obj['token'] = 'dummy-token'
                  //  obj['cid'] = 'C00925'
                  //  obj['tid'] = 'P002314'
                  //  obj['rank'] = 2
                  //  obj['id'] = '424'
                  //  obj['username'] = 'admin'
                  //  obj['store'] = 'boris'
                  //  dispatch({ type: 'SIGN_IN', creds: obj })
                   console.log("Error happend while requesting the data...")
        })
  }

  const reloadCashier = async (token) => {

        var obj = {}
        var category
        var unit
        var tax

        const config = {
          headers:{
            'X-Session-Token':token
          }
        };
        
        await axios.post(getHostName() + '/cashier/verify', {tid:getTid(), key:'no key needed', token:token, epoch:0}, config)
          .then(response => {
                      console.log("cashier verify")
                        if(response.data.result.isVerified){
                            obj['cid'] = response.data.result.cashier.cid
                            obj['tid'] = response.data.result.cashier.tid
                            obj['token'] = token
                            obj['rank'] = response.data.result.cashier.rank
                            obj['cashier_id'] = response.data.result.cashier.id
                            obj['username'] = response.data.result.cashier.username
                            obj['store'] = response.data.result.cashier.retailerName
                            category = response.data.categories.categories
                            unit = response.data.categories.units
                            tax = response.data.categories.taxes
                            getData(response.data.tid, token, response.data.id, response.data.rank).then(apiData => {	 
                              if(apiData.resultCode===0){ 			
                                  dispatch({ type:'SIGN_IN', creds:obj, articleCat:category, unitCat:unit, taxCat:tax, transactionLst:apiData.result })
                              }
                            })
                        }else{
                          console.log("...wrong token...")
                          console.log("Didnt verify cashier")
                            dispatch({ type: 'VALIDATE_CREDS', creds: -3 })
                        }
		 	              }).catch(error => {
					                    console.log("Error happend while reloading the page...")
		  	            })
  }
  
  useEffect(() => {
      // Fetch the token from storage then navigate to our appropriate place
      const bootstrapAsync = () => 
      {
            const token = window.location.href.split('token=')[1]
            //console.log("this is my token: " + token)
           // console.log("this is my cid: " + cid)

            if(token!==undefined&&(localStorage.getItem("isReload")==='false'))
            {
                  dispatch({type:'SET_LOADING'})
                  reloadCashier(token)   
            } 
      }

      bootstrapAsync();
  }, [])

  const authContext = useMemo(
    () => ({
      signIn: async data => {
            dispatch({ type:'SET_LOADING'})
            loginCashier(data.usrname, data.hashPasswd)
      },
      signOut: async data => { 
            dispatch({ type: 'SIGN_OUT' })
      },

      amountQR: () => dispatch({ type: 'AMOUNT_QR'}),

      generateQR: async data => {
      		dispatch({ type: 'GENERATE_QR', amount: data })
      },

      articlesQR: () => dispatch({ type: 'ARTICLES_QR'}),

      adminArticles: () => dispatch({ type: 'ADMIN_ARTICLES'}),

      setPageNumber: async data  => {  
          dispatch({ type: 'SET_PAGE_NUMBER', num: data })
      },

      setIsReconciled: async data  => {  
          dispatch({ type: 'SET_RECONCILED', num: data })
      },

      setDateStart: async data  => {  
        dispatch({ type: 'SET_DATE_START', date: data })
      },

      setDateEnd: async data  => {  
        dispatch({ type: 'SET_DATE_END', date: data })
      },

      setArticleList: async data  => {  
          dispatch({ type: 'SET_ARTICLE_LIST', items: data })
      },

      setCashierList: async data  => {  
          dispatch({ type: 'SET_CASHIER_LIST', items: data })
      },

      setTransactionList: async data  => {  
          dispatch({ type: 'SET_TRANSACTION_LIST', items: data })
      },

      adminCashiers: () => dispatch({ type: 'ADMIN_CASHIERS'}),

      transactionHistory: () => dispatch({ type: 'TRANSACTION_HISTORY'}),

      detailsLst: async data  => {  
          dispatch({ type: 'DETAILS_LST', item: data })
      },

      detailsList: () =>   dispatch({ type: 'DETAILS_LIST' }),

      editArticle: async data  => { 
          dispatch({ type: 'EDIT_ARTICLE', item: data })
      },

      resetEditedArticle: () => dispatch({ type: 'RESET_EA'}),

      editCashier: async data  => { 
          dispatch({ type: 'EDIT_CASHIER', item: data })
      },

      resetEditedCashier: () => dispatch({ type: 'RESET_EC'}),

      transactionsReport: async data  => { 
          dispatch({ type: 'TRANSACTIONS_REPORT' })
      },

      resetPN: () => dispatch({ type: 'RESET_PN'}),

      setProcessed: async data  => { 
        dispatch({ type: 'SET_PROCESSED', processed: data })
      },

      lastAddedCartItem: async data  => { 
        dispatch({ type: 'LAST_ADDED_CART_ITEM', itemAdded: data})   
      },
      addItemToCart: async data  => { 
          dispatch({ type: 'ADD_ITEM_TO_CART', items: data })
      },
      removeItemFromCart: async data  => { 
          var arr = []
          var quantity = 0
          for(let ele in data.items){
                  if(data.items[ele].item.id!==data.id){
                          arr=[...arr, data.items[ele]]
                          quantity+=parseInt(data.items[ele].quantity)
                  }   
            }
           
            dispatch({ type: 'REMOVE_ITEM_FROM_CART', items: arr, quantity: quantity })
      },

      resetCart: () => dispatch({ type: 'RESET_CART'}),

      setPrevPage: async data  => { 
          dispatch({ type: 'SET_PREV_PAGE', prevPageNum: data.prevPageNum })
      },
      changeLastItemQuantityNumber: async data  => { 
          var arr = []
          var quantity = 0;
          for(let ele in data.items){
                if(data.items[ele].item.id!==data.item.item.id){
                        arr=[...arr, data.items[ele]]
                }else if(data.items[ele].item.id===data.item.item.id){
                        quantity=parseInt(data.items[ele].quantity)+parseInt(data.item.quantity)
                        data.items[ele].quantity = quantity
                        arr=[...arr, data.items[ele]]
                }
          }
       
        dispatch({ type: 'CHANGE_LAST_ITEM_QUANTITY_NUMBER', items: arr })
      },
      incrementQN: async data  =>{ 
          dispatch({ type: 'INCREMENT_QN', quantNum: data })
      },
      partialStorne: async ()  =>  dispatch({ type: 'PARTIAL_STORNE' }),

      setArticleCategory: async data  => { 
          dispatch({ type: 'SET_ARTICLE_CATEGORY', items: data })
      },
      setQrUrl: async data  => { 
          dispatch({ type: 'SET_QR_URL', url: data })
      },
      setQrImage: async data  => { 
          dispatch({ type: 'SET_QR_IMAGE', image: data })
      },
      setMessage: async data  => { 
          dispatch({ type: 'SET_MESSAGE', msg: data })
      },
      signUp: async data => {
        // In a production app, we need to send user data to server and get a token
        // We will also need to handle errors if sign up failed
        // After getting token, we need to persist the token using `SecureStore`
        // In the example, we'll use a dummy token

        dispatch({ type: 'SIGN_IN', token: 'dummy-auth-token' });
      },
      setUsername: async data  => { 
        dispatch({ type: 'SET_USERNAME', username: data })
      },
    }),
    []
  );

  return (
    <AuthContext.Provider value={authContext}>
        <AnimatePresence exitBeforeEnter>
        <Router>
          <Routes>
              {state.isSignout&&state.pageNumber===null?
                            (!state.isLoading?
                                  <Route  path='/kekspos' 
                                          element={<Login validateCreds={state.isValidate} attempts={state.attempts} username={state.username}/>}/>:
                                  <Route  path='/kekspos' 
                                          element={<Loading />}/>): 
                                  <Route  path='/kekspos' 
                                          element={<Navigate  replace to={`/kekspos/${state.credentials.tid}`} />}
                                  />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/qr-iznos' 
                                    element={<EnterAmount cid={state.credentials.cid}/>}
                            />:<Route path='/kekspos/qr-iznos/*' 
                                      element={<Navigate  replace to="/kekspos" 
                                                          validateCreds={state.isValidate}/>}
                                />}
              {!state.isSignout?
                            <Route path='/kekspos/:tid/qr-kod' element={<GenerateQR processed={state.isProcessed}
                                                                                    message={state.message}
                                                                                    creds={state.credentials}
                                                                                    transactionList={state.transactionList} 
                                                                                    amount={state.amountToPay} 
                                                                                    cartItems={state.cartItems}
                                                                                    prevPage={state.prevPage}/>}
                            />:<Route path='/kekspos/qr-kod/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/povijest-transakcija' 
                                    element={<TransactionHistory  cid={state.credentials.cid}
                                                                  token={state.credentials.token}
                                                                  transactionList={state.transactionList}
                                                                  itemDetails={state.itemDetails}/>}
                            />:<Route path='/kekspos/:tid/povijest-transakcija/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />} 
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/detalji/:keks_id' 
                                    element={<DetailsList cid={state.credentials.cid}
                                                          token={state.credentials.token} 
                                                          item={state.itemDetails}
                                                          transactionList={state.transactionList} 
                                                          prevPage={state.prevPage}/>}
                            />:<Route path='/kekspos/:tid/detalji/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />} 
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/qr-artikl' 
                                    element={<Articles  cid={state.credentials.cid}
                                                        articleList={state.articleList} 
                                                        token={state.credentials.token}
                                                        quantityNumber={state.quantityNumber} 
                                                        lastItemAdded={state.lastItemAdded} 
                                                        cartItems={state.cartItems} />}
                            />:<Route path='/kekspos/:tid/qr-artikl/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/kosarica' 
                                    element={<Cart  cid={state.credentials.cid}
                                                    cartItems = {state.cartItems} 
                                                    quantityNumber={state.quantityNumber}/>}
                            />:<Route path='/kekspos/:tid/kosarica/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/izvjestaji' 
                                    element={<Report  cid={state.credentials.cid}
                                                      token={state.credentials.token}
                                                      rank={state.userRank}
                                                      cashierID={state.credentials.cashier_id}
                                                      item={state.itemDetails}
                                                      isReconciled={state.isReconciled}
                                                      dateStart={state.dateStart}
                                                      dateEnd={state.dateEnd}
                                                      processed={state.isProcessed}/>}
                            />:<Route path='/kekspos/:tid/izvjestaji/*' 
                                      element={<Navigate  replace to="/kekspos" />}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/admin-artikl' 
                                    element={<AdminArticles cid={state.credentials.cid}
                                                            token={state.credentials.token} 
                                                            editedArticle={state.editedArticle} 
                                                            articleList={state.articleList}
                                                            articleCategory={state.articleCategory}
                                                            unitCategory={state.unitCategory}
                                                            taxCategory={state.taxCategory}/>}
                            />:<Route path='/kekspos/:tid/admin-artikl/*' 
                                      element={<Navigate  replace to="/kekspos" />}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/admin-korisnik' 
                                    element={<AdminCashiers cid={state.credentials.cid}
                                                            userId={state.credentials.id} 
                                                            token={state.credentials.token} 
                                                            editedCashier={state.editedCashier} 
                                                            cashierList={state.cashierList}/>}
                            />:<Route path='/kekspos/:tid/admin-korisnik/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/djelomicno-storno/:keks_id' 
                                    element={<PartialStorne cid={state.credentials.cid}
                                                            token={state.credentials.token}
                                                            transactionList={state.transactionList} 
                                                            storneItem={state.itemDetails}
                                                            prevPage={state.prevPage} />}
                            />:<Route path='/kekspos/:tid/djelomicno-strono/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/uvjeti-koristenja' 
                                    element={<UserManual cid={state.credentials.cid} />}
                            />:<Route path='/kekspos/:tid/uvjeti-koristenja/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid/podijeli-qr-kod' 
                                    element={<SocialShare cid={state.credentials.cid}
                                                          qrURL={state.qrURL} 
                                                          qrImage={state.qrImage}/>}
                            />:<Route path='/kekspos/:tid/podijeli-qr-kod/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
              {!state.isSignout?
                            <Route  path='/kekspos/:tid' 
                                    element={<Main  creds={state.credentials}
                                                    rank={state.userRank} 
                                                    prevPage={state.prevPage}
                                                    />}
                            />:<Route path='/kekspos/*' 
                                      element={<Navigate  replace to="/kekspos"/>}
                                />}
               
          </Routes>
        </Router>
          
        </AnimatePresence>
    </AuthContext.Provider>
    )
   
 
}

export default App;
